import { CheckCircle2, LoaderCircle, ShieldAlert, Sparkles } from "lucide-react";

export const AmbassadorClaimVerifyModal = ({ foundingMembership, isSubmitting = false, onClose, onPrimaryAction, open, previewHref, primaryLabel = "Continue to Cockpit", publicPath, user }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[92] flex items-center justify-center bg-[#16120b]/70 px-4 py-8 backdrop-blur-sm" data-testid="ambassador-claim-verify-modal-overlay">
      <div className="w-full max-w-3xl rounded-[34px] border border-[#D4AF37]/22 bg-[linear-gradient(160deg,#171717_0%,#1F1F1F_56%,#26221E_100%)] p-6 text-[#F6F1E9] shadow-[0_30px_90px_rgba(22,18,11,0.32)] md:p-8" data-testid="ambassador-claim-verify-modal">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#D4AF37]">Private Showroom • Signature Concierge</p>
            <h2 className="mt-4 font-[Cormorant_Garamond,serif] text-4xl font-bold leading-none text-[#F6F1E9]" data-testid="ambassador-claim-verify-modal-heading">
              Claim & Verify your boutique showroom
            </h2>
            <p className="mt-4 text-sm leading-8 text-[#B8B0A5]" data-testid="ambassador-claim-verify-modal-copy">
              {user?.name}, your path-based portal is fully built in Private Showroom mode. Review your profile, confirm your CEA identity, and complete listing attestation before you trigger public publishing.
            </p>
          </div>
          <span className="rounded-full border border-[#D4AF37]/24 bg-white/5 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]" data-testid="ambassador-claim-verify-modal-path-pill">
            {publicPath}
          </span>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-3">
          {[
            {
              icon: ShieldAlert,
              title: "Compliance shield",
              body: "Your dashboard stays protected from public advertising exposure until Claim & Verify is completed.",
            },
            {
              icon: Sparkles,
              title: "Founding 18 scarcity",
              body: `${foundingMembership?.active_count ?? 1} seat is active, ${foundingMembership?.pending_count ?? 5} are pending activation, and ${foundingMembership?.available_count ?? 12} remain open before publish access closes.`,
            },
            {
              icon: CheckCircle2,
              title: "Portfolio attestation",
              body: "Every synced portfolio listing is preloaded and marked Awaiting Agent Attestation for final review.",
            },
          ].map((item) => {
            const Icon = item.icon;
            return (
              <div className="rounded-[26px] border border-[#D4AF37]/16 bg-[#252525] px-5 py-5" data-testid={`ambassador-claim-verify-step-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} key={item.title}>
                <Icon className="h-5 w-5 text-[#D4AF37]" />
                <p className="mt-4 text-sm font-bold uppercase tracking-[0.18em] text-[#F6F1E9]">{item.title}</p>
                <p className="mt-3 text-sm leading-7 text-[#B8B0A5]">{item.body}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-6 flex flex-wrap gap-3">
          <button className="gold-button" data-testid="ambassador-claim-verify-continue-button" disabled={isSubmitting} onClick={onPrimaryAction || onClose} type="button">
            {isSubmitting ? <LoaderCircle className="mr-2 h-4 w-4 animate-spin" /> : null}
            {primaryLabel}
          </button>
          <a className="outline-button !border-[#D4AF37]/28 !text-[#F6F1E9] hover:!bg-white/5" data-testid="ambassador-claim-verify-public-link" href={previewHref || publicPath} rel="noreferrer" target="_blank">
            Open Private Showroom
          </a>
        </div>
      </div>
    </div>
  );
};